export const radiusOptions = [
    { label: '5 miles', value: 5 },
    { label: '10 miles', value: 10 },
    { label: '15 miles', value: 15 },
    { label: '25 miles', value: 25 },
    { label: '35 miles', value: 35 },
    { label: '45 miles', value: 45 },
    { label: '55 miles', value: 55 },
    { label: '65 miles', value: 65 },
    { label: '75 miles', value: 75 },
    { label: '85 miles', value: 85 },
    { label: '95 miles', value: 95 },
    { label: '100 miles', value: 100 },
]
